import StartujemyZAktualnosciami from "./Articles/StartujemyZAktualnosciami";
import CzystyCodeReact from "./Articles/CzystyCodeReact";
import UnikaIneGrafikAI from "./Articles/UnikaIneGrafikAI";
import Proces48h from "./Articles/Proces48h";

export const articleRegistry = {
  "startujemy-z-aktualnosciami": StartujemyZAktualnosciami,
  "czysty-kod-react": CzystyCodeReact,
  "unikalne-grafiki-ai": UnikaIneGrafikAI,
  "proces-48h": Proces48h,
};
